module.exports = __webpack_public_path__ + "static/img/zhuanjie.01f2afc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zhuanjie.png
// module id = SC3D
// module chunks = 24